import React from 'react';
import PropTypes from 'prop-types';

import { useFormState } from 'react-final-form';

import '/components/forms/components/form-error/form-error.scss';

const FormError = ({ name }) => {
    const state = useFormState();
    const touched = state.touched[name];
    const errors = state.errors[name] || [];
    const error = errors[0];

    if (touched && error) {
        return (
            <div className="form-error">
                {error}
            </div>
        );
    }

    return null;
};

FormError.propTypes = {
    name: PropTypes.string.isRequired,
};

export { FormError };
